module.exports = __webpack_public_path__ + "img/icon_arzt_hinzufuegen.5816e69e.svg";